import { jsx as _jsx } from "react/jsx-runtime";
import { entityFromSchema, schemaHasAttributes } from 'criteria-entity-model';
import { List } from '../../list';
import { AttributeListItem } from './AttributeListItem';
export function AttributeList({ schema, parents }) {
    if (typeof schema !== 'object' || schema === null) {
        return null;
    }
    if (!schemaHasAttributes(schema)) {
        return null;
    }
    const entity = entityFromSchema(schema);
    return (_jsx(List, { data: entity.attributes, listItemKey: (attribute, index) => attribute.name, listItem: (attribute, index) => _jsx(AttributeListItem, { entity: entity, attribute: attribute, parents: parents }) }));
}
